/**
 * Deposit (acompte) rates per category — the 25 % option was replaced by 30 %.
 * Mirrors backend/services/booking_deposit.py (the server is the reference):
 *   scooters, airport transfers, private drivers: 0 / 30 / 50 — excursions: 30 / 50 / 100.
 * A listing still stored at 25 % reads as 30 %. Bookings are never concerned: they keep the
 * rate they were created with (snapshot stored in the booking).
 */
export const SCOOTER_DEPOSIT_CHOICES = [0, 30, 50];
export const TRANSPORT_DEPOSIT_CHOICES = [0, 30, 50];
export const EXCURSION_PAYMENT_CHOICES = [30, 50, 100];
/** Pre-selected on a NEW scooter listing only (and saved as such). Transport / excursions keep their own defaults. */
export const SCOOTER_DEFAULT_DEPOSIT = 30;

const LEGACY_RATE = 25;
const NEW_RATE = 30;

/** Scooter / transport rate: 25 → 30; other values outside the choices → nearest (≥ 37.5 → 50, else 30). */
export const toDepositChoice = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return NEW_RATE;
  if (n === LEGACY_RATE) return NEW_RATE;
  if (SCOOTER_DEPOSIT_CHOICES.includes(n)) return n;
  return n >= 37.5 ? 50 : NEW_RATE;
};

/** Excursion payment rate: 25 → 30; 30 / 50 / 100 as is; anything else (e.g. « full payment » stored as 0) → 100. */
export const toExcursionChoice = (value) => {
  const n = Number(value);
  if (n === LEGACY_RATE) return NEW_RATE;
  return EXCURSION_PAYMENT_CHOICES.includes(n) ? n : 100;
};

/**
 * Booking deposit (acompte) of a scooter listing, as the SERVER applies it when a booking is created — the page shows
 * the rate the traveller will really be asked. The server sends it (`booking_deposit_percentage`); without it the same
 * rule is applied here: 1. explicit `booking_deposit` (an explicit 0 % stays 0 %), 2. the old `deposit_type` /
 * `deposit_value` fields, 3. the default (50 %). The removed 25 % reads as 30 %. Stored data is never changed.
 */
export const scooterDepositPercent = (svc) => {
  if (svc && svc.booking_deposit_percentage !== undefined && svc.booking_deposit_percentage !== null
      && Number.isFinite(Number(svc.booking_deposit_percentage))) {
    return Number(svc.booking_deposit_percentage);
  }
  const d = (svc && svc.details) || {};
  const book = d.booking_deposit || {};
  let pct;
  if (book.value !== undefined && book.value !== null && Number.isFinite(Number(book.value))) pct = Number(book.value);
  else if (String(d.deposit_type || '').toLowerCase().trim() === 'percentage' && d.deposit_value !== undefined && d.deposit_value !== null
    && Number.isFinite(Number(d.deposit_value))) pct = Number(d.deposit_value);
  else pct = 50;
  return toDepositChoice(pct);
};
